/** @format */

import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { history } from '../../core/history';
import { Auth, tokenInfo } from '../../modules/auth/Auth';

import { simCardConstants } from '../../modules/simcard/actions';

import withStyles from '@material-ui/core/styles/withStyles';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Pager from '../../components/Adescom/PagerRange';

import GridContainer from '../../components/Grid/GridContainer.jsx';
import GridItem from '../../components/Grid/GridItem.jsx';

import adescomStyle from '../../assets/jss/adescom/adescomStyle';

import ViewButton from '../../components/Buttons/ViewButton';
import SynchronizeButton from '../../components/Buttons/SynchronizeButton';
import SettingsButton from '../../components/Buttons/SettingsButton';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import I18n from '../../components/Translate/I18n';
import { DateHelper } from '../../helpers/DateHelper';
import { SimCardOperationHelper } from '../../helpers/SimCardOperationHelper';
import { simCardInfoHelper } from '../../helpers/simCardInfoHelper';
import { iccidOperatorStatus, PlkStatusMap } from '../../helpers/iccidStatus';
import { Typography } from '@material-ui/core';
import orange from '@material-ui/core/colors/orange';
import green from '@material-ui/core/colors/green';
import SimCardInterface from '../../interfaces/platform/SimCardInterface';
import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { PlatformResellerLoader } from '../../modules/platformreseller/PlatformResellerLoader';
import { FilterManager, getNewFilterArr } from '../../modules/filter/FilterManager';
import { FilterReducerFieldName } from '../../modules/filter/FilterReducers';
import { FilterListReducerFieldName } from '../../modules/filter/FilterListReducers';
import { SimCardCollectionInterface } from '../../interfaces/collections/SimCardCollectionInterface';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import PaperedTable from '../../components/Table/PaperedTable';
import TableHeaderContentCell from '../../components/Table/TableHeaderContentCell';
import FilterList from '../../components/Filter/FilterList';
import { HeaderCheckBoxSelectListElement } from '../lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { IccidMvnoStatusHelper } from '../lib/search/IccidMvnoStatusHelper';
import TableFooter from '@material-ui/core/TableFooter';
import { StorageProductToCsv } from '../../modules/storage/StorageProductToCsv';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import { SimCardMnoTariffLoader } from '../../modules/tariffs/SimCardMnoTariffLoader';
import OplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import COLORS from '../../assets/themes/OPL/colors';
import { notificationConstants } from '../../modules/notifications/notifications';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import { useFilterParseToArray, useFilterParseToArrayWithColumn } from '../../modules/lib/hooks/useFilterParseToArray';

interface SimCardListProps {
    classes: any;
    dispatch: any;

    showMainLoader(value: boolean): void;

    headerFilterElementHasValue?: boolean;
    headerFilterElementName?: string;
    filterItemManage?: { key: string; value: string; rawValue: any; shouldRemove: boolean; item?: any };
    rows: null | SimCardCollectionInterface;
}

interface SimCardListState {
    rows: null | SimCardCollectionInterface;
    view: any;
    totalItems: number;
    info: any;
    filters: Array<Filter>;
    orders: Array<Order>;
    showClearFilterButton: boolean;
    platformResellers: Array<HeaderCheckBoxSelectListElement>;
    fupStatuses: Array<HeaderCheckBoxSelectListElement>;
    localStatuses: Array<HeaderCheckBoxSelectListElement>;
    mvnoStatuses: Array<HeaderCheckBoxSelectListElement>;
}

const _ = require('underscore');

class SimCardList extends React.Component<SimCardListProps, SimCardListState> {
    private itemLoader: ItemLoaders;
    private filterManage: FilterManager;
    private platformResellersLoader: PlatformResellerLoader;
    private simCardMnoTariffLoader: SimCardMnoTariffLoader;

    constructor(props: SimCardListProps) {
        super(props);
        this.state = {
            rows: null,
            view: null,
            totalItems: 0,
            info: null,
            filters: [],
            orders: [],
            showClearFilterButton: false,
            platformResellers: [],
            fupStatuses: this.fupStatus(),
            mvnoStatuses: this.mvnoStatusList(),
            localStatuses: this.localStatusList(),
        };

        this.itemLoader = new ItemLoaders(this.props.dispatch);
        this.platformResellersLoader = new PlatformResellerLoader(this.itemLoader);
        this.filterManage = new FilterManager();
        this.simCardMnoTariffLoader = new SimCardMnoTariffLoader(this.itemLoader);
    }

    componentDidMount(): void {
        this.setDefaultFilter((): void => {});
        this.loadPlatformResellers();
        this.simCardMnoTariffLoader.load({
            callback: (): void => {},
            orders: [{ name: 'constName', value: 'asc' }],
            filters: [{ name: 'typeValue', value: 'TARIFF' }],
        });
    }

    componentDidUpdate(prevProps: Readonly<SimCardListProps>, prevState: Readonly<SimCardListState>, snapshot?: any): void {
        const { dispatch, headerFilterElementHasValue, headerFilterElementName, filterItemManage } = this.props;

        if (filterItemManage && filterItemManage.shouldRemove) {
            const filters = getNewFilterArr(this.state.filters, filterItemManage.key, filterItemManage.value, filterItemManage.rawValue);
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE_ELEMENT,
                filterItemManage: { ...filterItemManage, shouldRemove: false },
            });
            this.setState({ filters: filters }, (): void => {
                this.updateFilterList(filters);
                dispatch({
                    type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                });
            });
        }
        if (headerFilterElementName) {
            if (headerFilterElementHasValue) {
                this.filterManage.manageElement(headerFilterElementName, headerFilterElementHasValue);
            } else {
                this.filterManage.manageElement(headerFilterElementName, false);
            }
            this.setState({ showClearFilterButton: this.filterManage.hasManageElement() });
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    setDefaultFilter = (callback: () => void): void => {
        this.setState(
            {
                showClearFilterButton: false,
                filters: [{ name: 'canceled', value: false }],
                orders: [{ name: 'id', value: 'DESC' }],
            },
            (): void => {
                callback();
                this.firstLoad();
            }
        );
    };

    updateOrderList = (orders: Array<Order>): void => this.setState({ orders: orders }, this.firstLoad);
    updateFilterList = (filters: Array<Filter>): void => this.setState({ filters: filters });

    clearFilter = (): void => {
        this.setDefaultFilter((): void => {
            const { dispatch } = this.props;
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                clearAll: true,
            });
            dispatch({
                type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
            });
        });
    };

    paginationCallbackFunction = (uri: string): void => {
        if (this.props.showMainLoader) {
            this.props.showMainLoader(true);
        }
        this.itemLoader.paginationCallWithCallback(
            uri,
            simCardConstants.SIM_CARD_LIST,
            (data: SimCardCollectionInterface): void => {
                this.setState({ rows: data });
                if (this.props.showMainLoader) {
                    this.props.showMainLoader(false);
                }
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    firstLoad = (): void => {
        const { filters, orders } = this.state;
        const { dispatch } = this.props;
        if (this.props.showMainLoader) {
            this.props.showMainLoader(true);
        }

        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_cards')),
            simCardConstants.SIM_CARD_LIST,
            useFilterParseToArrayWithColumn(filters,['fupState']),
            orders,
            (data: SimCardCollectionInterface): void => {
                this.setState({ rows: data });
                if (this.props.showMainLoader) {
                    this.props.showMainLoader(false);
                }
                dispatch({
                    type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
                    showRender: true,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    settingsButtonCallback = (simUri: { uri: string }, event: any): void => {
        const uri = FormGeneralHelper.getRouteUrl('/sim-card-edit' + simUri.uri);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.respectModifierPush(event, uri);
    };

    viewSimpleButtonCallback = (simUri: { uri: string }, event: any): void => {
        const uri = FormGeneralHelper.getRouteUrl('/sim-card-edit' + simUri.uri);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.respectModifierPush(event, uri);
    };

    getUri = (simCard: SimCardInterface): { uri: string; simCardId: number } => {
        return {
            uri: simCard['@id'],
            simCardId: simCard.id,
        };
    };

    synchronizeCall = (params: any): void => {
        simCardInfoHelper.onSuccess(this, 'info', params, this.synchronizeCallback);
    };

    synchronizeCallback = (param: any): void => {
        const { dispatch } = this.props;
        param.fullSynchronize = false;
        SimCardOperationHelper.synchronizeCallback(param, dispatch);
    };

    iccidTypeList = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { name: 'E', value: 1 },
            { name: 'Q', value: 2 },
        ];
    };

    mvnoStatusList = (): Array<HeaderCheckBoxSelectListElement> => {
        const element = new IccidMvnoStatusHelper();
        const items = element.getList();
        items.push({ name: 'pools:state.not_defined', value: 0 });
        return items;
    };

    loadPlatformResellers = (): void => {
        this.platformResellersLoader.loadPlatformResellers({
            callback: () => {
                this.setState({ platformResellers: this.platformResellersLoader.getPlatformResellersHeaderList() });
            },
            filters: [{ name: 'deleted', value: 0 }],
        });
    };

    localStatusList = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { name: 'simcard:list.active', value: 3 },
            { name: 'simcard:list.deleted', value: 1 },
            { name: 'simcard:list.preactive', value: 2 },
            { name: 'simcard:list.wait_for_remove', value: 4 },
        ];
    };

    fupStatus = (): Array<HeaderCheckBoxSelectListElement> => {
        return [
            { name: 'simcard:list.red', value: 3 },
            { name: 'simcard:list.green', value: 1 },
            { name: 'simcard:list.yellow', value: 2 },
        ];
    };

    exportToCsv = (): void => {
        const { filters, orders, rows } = this.state;
        const { showMainLoader, dispatch } = this.props;
        if (rows && !rows['hydra:totalItems']) {
            NotificationHelper.notifyError('general:common.no_data_to_export', dispatch);
            return;
        }
        const toCsv = new StorageProductToCsv(this.itemLoader, this.simCardMnoTariffLoader);
        toCsv.exportToCsv(Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN, orders, filters, showMainLoader);
    };

    render(): ReactNode {
        const { classes } = this.props;
        const { info, showClearFilterButton, rows, filters, orders, platformResellers } = this.state;

        const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
        const tableStickyHeader = { root: classes.tableStickyHeader };
        const tableCellRoot = { root: classes.tableCellRootBordered };
        const tableStickyCommand = { root: classes.tableStickyCommand };

        return (
            <GridContainer>
                <GridItem xs={12} md={12} lg={12}>
                    <PaperedTable
                        beforeTableContent={
                            <GridContainer>
                                <GridItem xs={12} className={classes.beforeTableContent}>
                                    <CustomTextButtom
                                        callback={this.firstLoad}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.search"
                                        size={'lg'}
                                    />
                                    {showClearFilterButton && (
                                        <CustomTextButtom
                                            callback={this.clearFilter}
                                            callbackParam={{}}
                                            color="primary"
                                            label="general:common.clear"
                                            size={'lg'}
                                        />
                                    )}
                                    <CustomTextButtom
                                        callback={this.exportToCsv}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.export_to_csv"
                                        size={'lg'}
                                    />
                                    <FilterList />
                                </GridItem>
                            </GridContainer>
                        }
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell classes={tableStickyCommand} padding="none" align="left">
                                    <TableHeaderContentCell textAlign="left" title="general:common.commands" onlyFilter={true} />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="simcard:list.identificator"
                                        fieldName="id"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="number"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="center"
                                        title="pools:sim.service_profile"
                                        fieldName="mvnoTariffId"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        elementList={this.simCardMnoTariffLoader.getHeaderList()}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        nullable={true}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="center"
                                        title="simcard:list.msisdn_number"
                                        fieldName="msisdnAll"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="number"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="center"
                                        title="prov:list.imsi"
                                        fieldName="imsi"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="number"
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                {/*<TableCell classes={tableStickyHeader} padding="none" align="center">*/}
                                {/*    <TableHeaderContentCell*/}
                                {/*        textAlign="left"*/}
                                {/*        title="simcard:list.iccid_type"*/}
                                {/*        fieldName="iccidTypeMapped"*/}
                                {/*        showSort={true}*/}
                                {/*        onlyFilter={false}*/}
                                {/*        searchFieldType="select"*/}
                                {/*        selectComponent="headerCheckBoxSimpleList"*/}
                                {/*        defaultDirection="desc"*/}
                                {/*        elementList={this.iccidTypeList()}*/}
                                {/*        filters={filters}*/}
                                {/*        sort={orders}*/}
                                {/*        updateOrderList={this.updateOrderList}*/}
                                {/*        updateFilterList={this.updateFilterList}*/}
                                {/*        searchActionCallback={this.firstLoad}*/}
                                {/*    />*/}
                                {/*</TableCell>*/}
                                {/*{Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN && (*/}
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="center"
                                        title="simcard:list.partner"
                                        fieldName="partnerPlatformResellerId"
                                        sortFieldName="platformResellerName"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        elementList={platformResellers}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                {/*)}*/}
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="right"
                                        title="simcard:list.activated_from"
                                        fieldName="activateDate"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="date"
                                        dateFormat="RRRR-MM-DD"
                                        beforeSetToMax={true}
                                        afterSetToMin={true}
                                        dateFromTo={true}
                                        breakLine={true}
                                        timeFormat={false}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        nullable={true}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="right"
                                        title="simcard:list.activated_to"
                                        fieldName="expiryDate"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="date"
                                        dateFormat="RRRR-MM-DD"
                                        beforeSetToMax={true}
                                        afterSetToMin={true}
                                        dateFromTo={true}
                                        breakLine={true}
                                        timeFormat={false}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        nullable={true}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="right"
                                        title="simcard:list.deleted_at"
                                        fieldName="removePeriod"
                                        showSort={true}
                                        onlyFilter={false}
                                        defaultDirection="desc"
                                        searchFieldType="date"
                                        dateFormat="RRRR-MM-DD"
                                        beforeSetToMax={true}
                                        afterSetToMin={true}
                                        dateFromTo={true}
                                        breakLine={true}
                                        timeFormat={false}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                        nullable={true}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="simcard:list.sim_card_status_mvno"
                                        fieldName="mvnoStatus"
                                        showSort={true}
                                        onlyFilter={false}
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        defaultDirection="desc"
                                        elementList={this.state.mvnoStatuses}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="simcard:list.status_local"
                                        fieldName="statusLocal"
                                        showSort={true}
                                        onlyFilter={false}
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        defaultDirection="desc"
                                        elementList={this.state.localStatuses}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyHeader} padding="none" align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="simcard:list.fup_status"
                                        fieldName="fupState"
                                        showSort={true}
                                        onlyFilter={false}
                                        searchFieldType="select"
                                        selectComponent="headerCheckBoxSimpleList"
                                        defaultDirection="desc"
                                        elementList={this.state.fupStatuses}
                                        filters={filters}
                                        sort={orders}
                                        updateOrderList={this.updateOrderList}
                                        updateFilterList={this.updateFilterList}
                                        searchActionCallback={this.firstLoad}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows &&
                                rows['hydra:member'] &&
                                rows['hydra:member'].map((row) => {
                                    let background = null;
                                    if (SimCardOperationHelper.isFullyActive(row) === false) {
                                        background = COLORS.ADDITIONAL.ADDITIONAL_4;
                                    }
                                    if (row.deleted) {
                                        background = COLORS.ADDITIONAL.ADDITIONAL_5;
                                    }

                                    return (
                                        <TableRow /**style={{ backgroundColor: background }}**/ key={row.id} hover>
                                            <TableCell classes={tableControlStickyHeader} padding="none" align="left">
                                                {(Auth.isExpertMode() || row.mvnoStatus !== PlkStatusMap.CANCELLED) && (
                                                    <SettingsButton
                                                        callback={this.settingsButtonCallback}
                                                        callbackParam={this.getUri(row)}
                                                        tooltipTitle="general:common.settings"
                                                    />
                                                )}
                                                {UserRoleHelper.checkRole(roles.ROLE_BLOCK_OPERATION_SYNCHRONIZE_POST) &&
                                                    (Auth.isExpertMode() || SimCardOperationHelper.isFullyActive(row)) &&
                                                    !row.deleted && (
                                                        <SynchronizeButton
                                                            classes={classes.tableButton}
                                                            callback={this.synchronizeCall}
                                                            callbackParam={SimCardOperationHelper.getUri(row)}
                                                            tooltipTitle="general:common.synchronize"
                                                        />
                                                    )}
                                                {!Auth.isExpertMode() && row.mvnoStatus === PlkStatusMap.CANCELLED && (
                                                    <ViewButton callback={this.viewSimpleButtonCallback} callbackParam={this.getUri(row)} />
                                                )}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                                {row.id}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                                {row.mvnoTariffId && this.simCardMnoTariffLoader.getName(row.mvnoTariffId)}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                                {row.deleted ? row.lastMsisdn : row.msisdn}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                                {row.imsi}
                                            </TableCell>
                                            {/*<TableCell classes={tableCellRoot} padding="none" align="center">*/}
                                            {/*    {row.iccidType}*/}
                                            {/*</TableCell>*/}
                                            {/*{Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN && (*/}
                                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                                {row.client.platformResellerName}
                                            </TableCell>
                                            {/*)}*/}
                                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                                {row.mvnoStatus && row.mvnoStatus > PlkStatusMap.PREACTIVATED && DateHelper.format(row.activateDate)}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                                {DateHelper.format(row.expiryDate)}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                                {DateHelper.format(row.removePeriod)}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                                <I18n
                                                    trans={iccidOperatorStatus(row.mvnoStatus)}
                                                    valueObject={{ status: '(' + row.mvnoStatus + ')' }}
                                                />
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                                <I18n trans={SimCardOperationHelper.getSimCardStatus(row)} />
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} padding="none" align="left">
                                                <I18n trans={SimCardOperationHelper.getSimCardFupStatus(row)} />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            {!rows && (
                                <TableRow>
                                    <TableCell colSpan={11} align="left">
                                        <I18n trans="general:common.empty_list" />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            {rows && (
                                <TableRow>
                                    <TableCell colSpan={11}>
                                        <Pager callback={this.paginationCallbackFunction} views={rows} />
                                    </TableCell>
                                </TableRow>
                            )}
                            {/*{rows && (*/}
                            {/*    <TableRow>*/}
                            {/*        <TableCell colSpan={11}>*/}
                            {/*            <GridContainer style={{ marginLeft: '20px', marginBottom: '20px' }}>*/}
                            {/*                <GridItem xs={12} md={12} lg={12}>*/}
                            {/*                    <GridContainer>*/}
                            {/*                        <GridItem xs={12}>*/}
                            {/*                            <Typography variant="subtitle2">*/}
                            {/*                                <I18n trans="prov:list.legend" />*/}
                            {/*                            </Typography>*/}
                            {/*                        </GridItem>*/}
                            {/*                        <GridItem xs={1} style={{ backgroundColor: COLORS.ADDITIONAL.ADDITIONAL_5 }} />*/}
                            {/*                        <GridItem xs={11}>*/}
                            {/*                            <I18n trans="simcard:list.deleted" />*/}
                            {/*                        </GridItem>*/}
                            {/*                        <GridItem xs={1} style={{ backgroundColor: COLORS.ADDITIONAL.ADDITIONAL_4 }} />*/}
                            {/*                        <GridItem xs={11}>*/}
                            {/*                            <I18n trans="simcard:list.not_active" />*/}
                            {/*                        </GridItem>*/}
                            {/*                    </GridContainer>*/}
                            {/*                </GridItem>*/}
                            {/*            </GridContainer>*/}
                            {/*        </TableCell>*/}
                            {/*    </TableRow>*/}
                            {/*)}*/}
                            <TableRow>
                                <TableCell colSpan={11}>{info}</TableCell>
                            </TableRow>
                        </TableFooter>
                    </PaperedTable>
                </GridItem>
            </GridContainer>
        );
    }
}

const mapStateToProps = (state: any): any => {
    const { filterReducer } = state;
    if (filterReducer && filterReducer.type === FilterReducerFieldName.HEADER_FILTER_MANAGE_ELEMENT && filterReducer.item && filterReducer.value) {
        console.log(filterReducer);
        if (filterReducer.removeFilterElement) {
            return {
                filterItemManage: {
                    key: filterReducer.item.elementName,
                    value: filterReducer.value,
                    rawValue: filterReducer.item.rawValue,
                    shouldRemove: filterReducer.removeFilterElement,
                },
            };
        } else {
            return {
                filterItemManage: {
                    key: filterReducer.item.elementName,
                    value: filterReducer.value,
                    shouldRemove: filterReducer.removeFilterElement,
                },
            };
        }
    }

    if (filterReducer && filterReducer.headerFilterElementName) {
        return {
            headerFilterElementHasValue: filterReducer.headerFilterElementHasValue,
            headerFilterElementName: filterReducer.headerFilterElementName,
        };
    }

    return {};
};

export default compose<any, any>(connect(mapStateToProps), withStyles(OplAppStyle))(SimCardList);
